module.exports = __webpack_public_path__ + "static/media/remove-group-to-person.0a194ecd.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/manual/remove-group-to-person.jpg
// module id = 1917
// module chunks = 0